import LabelField from '@app/components/atoms/LabelField/LabelField'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const CodeSection = ({ register, errors, control, getValues, voucherType }) => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.TYPE_VOUCHER')}>
          <Controller
            control={control}
            name="type"
            render={() => (
              <TextField
                disabled
                fullWidth
                error={!!errors.name}
                helperText={errors.type?.message}
                id="type"
                name="type"
                size="small"
                value={t(`VOUCHER.${voucherType.toUpperCase()}`)}
                variant="outlined"
              />
            )}
          />
        </LabelField>
      </Grid>

      <Grid item sx={{ display: VOUCHER_TYPE.STANDARD === voucherType ? 'none' : 'block' }} xs={12}>
        <LabelField title={t('VOUCHER.MIN')}>
          <Controller
            control={control}
            name="limit_min"
            render={({ field }) => (
              <TextField
                {...field}
                {...register('limit_min')}
                fullWidth
                error={!!errors.limit_min}
                helperText={errors.limit_min?.message}
                name="limit_min"
                size="small"
                type="number"
                value={getValues('limit_min')}
                variant="outlined"
              />
            )}
          />
        </LabelField>
      </Grid>

      <Grid item sx={{ display: VOUCHER_TYPE.STANDARD === voucherType ? 'none' : 'block' }} xs={12}>
        <LabelField title={t('VOUCHER.MAX')}>
          <Controller
            control={control}
            name="limit_max"
            render={() => (
              <TextField
                {...register('limit_max')}
                fullWidth
                error={!!errors.limit_max}
                helperText={errors.limit_max?.message}
                name="limit_max"
                size="small"
                type="number"
                value={getValues('limit_max')}
                variant="outlined"
              />
            )}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default CodeSection
